import bg from "./guest-bg.png";
import "./guest-page-header.scss";

export default function GuestPageHeader({ title }: { title: string }) {
   return (
      <div className="guest-page-header" style={{ backgroundImage: `url(${ bg })`}}>
         <h1> { title } </h1>
      </div>
   )
}